var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcHeadsetOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1458 28.481L3.14453 2.89793L4.61031 1.75195L24.6116 27.335L23.1458 28.481Z",
    fill: "#E9226A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7432 24.6543H28.0766V14.7794H22.7748V4H8.63983L10.8144 6.78919V6.51268H20.2538V18.8961L24.7432 24.6543ZM10.8144 9.81519L8.30176 6.5924V14.7794H3V24.6626H10.8144V9.81519ZM20.2538 21.9221L22.3839 24.6543H20.2538V21.9221Z",
    fill: "#E9226A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHeadsetOff);
export default __webpack_public_path__ + "static/media/ic_headset_off.aa063d60c1c1ca75a21ab607581bdf30.svg";
export { ForwardRef as ReactComponent };